import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

interface FormData {
  name: string;
  email: string;
  age: string;
  gender: string;
  phone: string;
}

const UpdateRegistration: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    age: '',
    gender: '',
    phone: '',
  });

  const [message, setMessage] = useState<string>('');
  const apiBase = process.env.REACT_APP_API_URL || '';

  useEffect(() => {
    const fetchRegistration = async () => {
      try {
        const response = await axios.get(
          `${apiBase}/api/registration/registrations/${id}/`
        );

        setFormData({
          name: response.data.name || '',
          email: response.data.email || '',
          age: String(response.data.age || ''),
          gender: response.data.gender || '',
          phone: response.data.phone || '',
        });
      } catch (error) {
        setMessage('查無此筆資料');
      }
    };

    if (id) {
      fetchRegistration();
    }
  }, [id, apiBase]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await axios.put(
        `${apiBase}/api/registration/registrations/${id}/`,
        {
          ...formData,
          age: Number(formData.age),
        }
      );
      setMessage('更新成功');
    } catch (error) {
      setMessage('更新失敗');
    }
  };

  const handleDelete = async () => {
    const confirmed = window.confirm('確定要刪除這筆資料嗎？');
    if (!confirmed) return;

    try {
      await axios.delete(
        `${apiBase}/api/registration/registrations/${id}/`
      );
      alert('刪除成功');
      navigate('/registrations');
    } catch (error) {
      setMessage('刪除失敗');
    }
  };

  return (
    <div className="register-form-container">
      <h2>修改報名資料</h2>
      {message && <p className="message">{message}</p>}

      <form onSubmit={handleUpdate} className="register-form">
        <input
          type="text"
          name="name"
          placeholder="姓名"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <input
          type="number"
          name="age"
          placeholder="年齡"
          value={formData.age}
          onChange={handleChange}
          required
        />

        <select
          name="gender"
          value={formData.gender}
          onChange={handleChange}
          required
        >
          <option value="">請選擇性別</option>
          <option value="Male">男</option>
          <option value="Female">女</option>
          <option value="Other">其他</option>
        </select>

        <input
          type="text"
          name="phone"
          placeholder="電話"
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <button type="submit">更新資料</button>
      </form>

      <div style={{ marginTop: '1rem' }}>
        <button type="button" onClick={handleDelete}>
          刪除這筆資料
        </button>
      </div>
    </div>
  );
};

export default UpdateRegistration;